export default class ItemTarea {
    Formulario: string;
    FechaPrevistaFin: string;
    Descripcion: string;
    Nombre: string;
    Direccion: string;
    CPostal: string;
    Pais: string;
    Provincia: string;
    Poblacion: string;
    Observaciones: string;
    Id: number;
    IdOrden: number;
    Orden: number;
    FechaEnvio: string;
    FechaEntrega: string;
    FechaFinalizacion: string;
    FormularioDatos: string;
    Para: string;
    De: string;
    ControlDeTiempos: number;
    FechaHoraInicioPrevista: string;
    CodCliente: number;
    CodDireccion: number;
    PosicionGPS: string;
    IdTrabajo: number;
    Referencia: string;
    TiempoPrevisto: number;
    PEContacto: boolean;
    PEDireccion: boolean;
    VHInicio: string;
    VHFinal: string;
    ImporteCobro: number;
    ConceptoCobro: string;
    ImporteACobrar: number;

    constructor () {
        this.Formulario = "";
        this.FechaPrevistaFin = "";
        this.Descripcion = "";
        this.Nombre = "";
        this.Direccion = "";
        this.CPostal = "";
        this.Pais = "";
        this.Provincia = "";
        this.Poblacion = "";
        this.Observaciones = "";
        this.Id = 0;
        this.IdOrden = 0;
        this.Orden = 0;
        this.FechaEnvio = "";
        this.FormularioDatos = "";
        this.Para = "";
        this.De = "";
        this.ControlDeTiempos = 1;
        this.FechaHoraInicioPrevista = "";
        this.PosicionGPS = "";
        this.FechaPrevistaFin = "";
        this.FechaEntrega = "";
        this.FechaFinalizacion = "";
        this.CodCliente = 0;
        this.CodDireccion = 0;
        this.IdTrabajo = 0;
        this.Referencia = "";
        this.TiempoPrevisto = 0;
        this.PEContacto = false;
        this.PEDireccion = false;
        this.VHInicio = "";
        this.VHFinal = "";
        this.ImporteCobro = 0;
        this.ConceptoCobro = "";
        this.ImporteACobrar = 0;
    };
};

